import React from 'react';
import { Form, Field } from 'react-final-form';
import { TextField } from 'final-form-material-ui';
import { Grid, Button, MenuItem, CircularProgress, Typography } from '@material-ui/core';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import validator from 'validator';
import toast from 'react-hot-toast';
import emailjs from 'emailjs-com';
import fireBaseApp from '../Firebase';
import siteConfig from '../siteConfig';

const db = getFirestore(fireBaseApp);

const onSubmit = async (values, form) => {
  const data = {
    firstName: values.firstName,
    lastName: values.lastName,
    email: values.email,
    phone: values.phone,
    service: values.service || '',
    notes: values.notes || '',
  };

  try {
    await addDoc(collection(db, 'quote_requests'), data);
    await emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      data,
      process.env.REACT_APP_EMAILJS_USER_ID
    );
    toast.success("Thank you! We'll be in touch soon.");
    setTimeout(() => form.restart());
  } catch (e) {
    console.error('Error submitting quote request: ', e);
    toast.error(`Sorry, something went wrong. Please try again or call us at ${siteConfig.phoneDisplay}.`, {
      duration: 8000,
    });
  }
};

const validate = (values) => {
  const errors = {};
  if (!values.firstName) {
    errors.firstName = 'Required';
  }
  if (!values.lastName) {
    errors.lastName = 'Required';
  }
  if (!values.email) {
    errors.email = 'Required';
  } else if (!validator.isEmail(values.email)) {
    errors.email = 'Please enter a valid email';
  }
  if (!values.phone) {
    errors.phone = 'Required';
  } else if (!validator.isMobilePhone(values.phone)) {
    errors.phone = 'Please enter a valid phone number';
  }
  return errors;
};

export default function RequestQuoteForm({ services }) {
  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      render={({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Field fullWidth required name="firstName" component={TextField} variant="outlined" type="text" label="First name" autoComplete="given-name" />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field fullWidth required name="lastName" component={TextField} variant="outlined" type="text" label="Last name" autoComplete="family-name" />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field fullWidth required name="email" component={TextField} variant="outlined" type="email" label="Email" autoComplete="email" />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field fullWidth required name="phone" component={TextField} variant="outlined" type="tel" label="Phone" autoComplete="tel" />
            </Grid>
            <Grid item xs={12}>
              <Field
                fullWidth
                select
                name="service"
                component={TextField}
                variant="outlined"
                label="Service you're interested in"
              >
                {services.map((value) => (
                  <MenuItem value={value} key={value}>
                    {value}
                  </MenuItem>
                ))}
              </Field>
            </Grid>
            <Grid item xs={12}>
              <Field
                fullWidth
                name="notes"
                component={TextField}
                variant="outlined"
                multiline
                minRows={4}
                label="Tell us about your project (optional)"
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                type="submit"
                fullWidth
                disabled={submitting}
                startIcon={submitting ? <CircularProgress size={18} color="inherit" /> : null}
              >
                {submitting ? 'Sending…' : 'Request my free estimate'}
              </Button>
              <Typography variant="body2" color="textSecondary" style={{ marginTop: 12, textAlign: 'center' }}>
                We'll only use your details to contact you about your estimate.
              </Typography>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
}
